<template>
  <el-card shadow="never" class="bid bid-item-view">
    <div id="bid-info-mobile">
      <el-row>
        <el-col :span="24">
          <div style="margin-top: 12px; margin-bottom: 8px">
            <span class="number_date" :class="carrierRequest ? 'green' : ''">
              {{ getTitle }}
            </span>
            <br />
            <span class="number_date">
              ИСПОЛНИТЕЛЬ
              <span v-if="bid.org_performer_id">
                {{ performerName.toUpperCase() || '-' }}
              </span>
            </span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="shipping_info_left">
          <el-row
            v-if="canAction('shipping_stat')"
            tag="p"
            type="flex"
            align="middle"
            justify="start"
            class="weight ta-r mb0"
          >
            <img
              v-if="bid.managers && bid.managers.length"
              src="@/assets/img/user-green.png"
              class="manager-icon"
              @click="$alert(bid.managers[0].fio)"
            />
            <span v-if="bid.views_count" class="count-view">
              <i class="el-icon-view" />
              {{ bid.views_count }}
            </span>
            Всего: {{ bid.weight }} т., погружено:
            {{ bid.countAuto || 0 }} авто.
          </el-row>
          <el-row
            tag="p"
            type="flex"
            align="middle"
            justify="end"
            class="weight ta-r m0"
          >
            <div>{{ getTypeCode }}</div>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="shipping-row-mobile">
          <div @click="$alert(bid.load_point)">
            <h2 class="mobile-h2">{{ loadLocationFilter(bid) }}</h2>
            <p class="mobile-ri_p1">{{ bid.load_point.split(',')[0] }}</p>
          </div>
          <div class="mobile-sh_dist">
            <img src="@/assets/img/arrow-route.svg" />
            <p class="mobile-ri_p2">{{ bid.distance }} км</p>
          </div>
          <div>
            <h2 class="mobile-h2">{{ findStevedore(bid) || 'не указан' }}</h2>
            <p class="mobile-ri_p1">
              {{ bid.unload_point.split(',')[1] }}{{ showExporter ? ',' : '' }}
              <span>
                <span v-if="showExporter">{{ showExporter }}</span>
              </span>
            </p>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <h2 class="mobile-h2">
            <img src="@/assets/img/grass.svg" alt="" />
            {{ freightsType }}
          </h2>
        </el-col>
      </el-row>
      <el-row>
        <button :id="bid.id" class="mob-btn-map">Подробнее</button>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { typeCodes } from '@/datas/consts'
import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'BidInfo',
  mixins: [shippingMixin],
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      getLibObj: 'libs/getLibObj',
      list: 'organizations/getExporters',
      exporterName: 'organizations/getExpShortNameById',
      getOrgById: 'organizations/getOrgById',
    }),
    performerName() {
      return this.getOrgById(this.bid.org_performer_id)
    },
    getTypeCode() {
      const type = typeCodes.find(t => t.label === this.bid.type_code)

      return type ? `Тип заявки: ${type.full || type.title}` : ''
    },
    showExporter() {
      const { unload_point, exporter_id } = this.bid

      return unload_point.split(',')[1]?.includes('Новороссийск') &&
        this.list.length &&
        this.canAction('chooseExporter')
        ? this.exporterName(exporter_id) || 'Экспортер не указан'
        : ''
    },
    freightsType() {
      return this.getLibObj('freightTypes')[this.bid.freight_id]
    },
    getTitle() {
      const { id, client_short_name, created_at } = this.bid
      let text = `Перевозка №${id}`

      text += this.carrierRequest
        ? this.carrierRequest
        : `. Дата создания ${this.dateToFormat(created_at)}`
      text += client_short_name ? ', ' + client_short_name : ''

      return text
    },
    carrierRequest() {
      const { carrier_request_number: number, carrier_request_date: date } =
        this.bid

      return number && date
        ? ` по поручению №${number} от ${this.dateToFormat(
            date,
            'defaultDateRu',
          )}`
        : ''
    },
  },
}
</script>

<style lang="sass">
#bid-info-mobile
  padding-bottom: 10px
  min-height: 150px
  .mob-btn-map
    color: #FFF
    background-color: #67C23A
    border: 1px solid #67C23A
    width: 100%
    padding: 12px
    border-radius: 4px
    transition: 0.6s linear

    &:hover
      cursor: pointer
      color: #FFF
      background-color: darken(#67C23A, 5)
      border: 1px solid #67C23A
  .m0
    margin: 0
  .mb0
    margin-bottom: 0
  .mt6
    margin-top: 4px!important
  .sh-span
    font-size: 14px
  .sh-comment
    color: #409EFF
    border-bottom: 1px solid
    cursor: pointer
  .mobile-sh_dist
    display: flex
    align-items: center
  .number_date
    font-size: 14px
    line-height: 17px
    color: rgba(0, 0, 0, 0.47)
    border-radius: 5px
    &.green
      color: #00bf40
  .distance
    font-size: 24px
    line-height: 17px
    color: #000000
    display: flex
    align-items: center
    justify-content: flex-end
    margin: 10px 0
    img
      margin-right: 10px
      max-width: 26px
      max-height: 26px
  .d_h2
    margin: 0
    font-size: 18px
  .time
    font-size: 14px
    line-height: 17px
    color: rgba(0, 0, 0, 0.47)
    border-radius: 5px
    margin: 0 0 15px 0
    span
      margin: 0 5px
  .shipping-row-mobile
    display: flex
    flex-direction: column
    align-items: start
    .mobile-h2
      margin: 0
    p
      font-size: 12px
      line-height: 17px
      &.mobile-ri_p1
        color: rgba(0, 0, 0, 0.5)
        margin: 0
        span
          margin-left: 5px
      &.mobile-ri_p2
        color: #000000
        margin-left: 8px
  .shipping-h2
    margin-bottom: 0
    display: flex
    justify-content: center
  .shipping_info_left
    text-align: left
    .manager-icon
      width: 17px
      margin-right: 10px
      cursor: pointer
      border-radius: 50%
    .count-view
      margin-right: 10px
      &>i
        margin-right: 5px
    .weight
      font-size: 14px
      line-height: 17px
      color: rgba(0, 0, 0, 0.7)
      border-radius: 5px
</style>
